<script lang="ts" setup>
import { computed } from 'vue'
import IconBell from '@/assets/images/icon/icon_bell.svg'
import ABaseIcon from '@/components/atoms/ABaseIcon/index.vue'
import ATooltip from '@/components/atoms/ATooltip/index.vue'

/**
 * Props
 */
type Props = {
  count: number
  isPanelOpened: boolean
}
const props = withDefaults(defineProps<Props>(), {
  count: 0,
  isPanelOpened: false,
})

/**
 * Emits
 */
type Emits = {
  (e: 'togglePanel'): void
}
const emit = defineEmits<Emits>()

/**
 * Computed
 */
const displayCount = computed(() => {
  if (props.count > 9) {
    return '9+'
  }
  return props.count
})
</script>

<template>
  <div class="notification-switch">
    <ATooltip
      :tip="undefined as any"
      position="bottom"
      open-on-hover
      activator-class="notification-button-activator"
    >
      <template #activator>
        <button
          class="notification-button"
          :class="{ 'is-active': props.isPanelOpened }"
          @click="emit('togglePanel')"
        >
          <ABaseIcon :src="IconBell" />
          <div
            v-if="props.count > 0"
            class="unread-badge"
          >
            <span class="unread-badge-count">{{ displayCount }}</span>
          </div>
        </button>
      </template>
      <template #balloon>
        <p
          v-if="!props.isPanelOpened"
          class="tooltip-text"
        >
          {{ $t("common.notification.title") }}
        </p>
      </template>
    </ATooltip>
  </div>
</template>

<style scoped>
.notification-switch {
  .notification-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 4px;
    border-radius: 2px;

    &.is-active,
    &:hover {
      background-color: rgb(var(--v-theme-primary-lighten-2));
    }
  }

  .unread-badge {
    position: absolute;
    top: -2px;
    right: -3px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background-color: rgb(var(--v-theme-ui-alert));
    border-radius: 50%;

    .unread-badge-count {
      font-family: Roboto, sans-serif;
      font-size: 10px;
      line-height: 1;
      color: rgb(var(--v-theme-ui-white));
    }
  }
}

.tooltip-text {
  padding: 6px 10px;
  color: rgb(var(--v-theme-ui-text-black));
  white-space: nowrap;
  background-color: rgb(var(--v-theme-ui-white));
  border-radius: 4px;
  box-shadow: 0 0 8px rgba(var(--v-theme-ui-black), 16%);
}
</style>
